<template>
  
</template>

<script>
import { PartnerService } from "../../services/partnerService";
import { OnBoardingServices } from "../../services/onBoardingService";
import { SummaryServices } from "../../services/summaryService";
const OnBoardingService = new OnBoardingServices();
const partnerService = new PartnerService();
const summaryService = new SummaryServices();
import Modal from "../../widgets/newModalWidget";
import TextInput from "../../widgets/TextInput.vue";
import DropDown from "../../widgets/DropDown";
import Datepicker from "../../widgets/DatePicker";
import loadingSpinner from "../../widgets/LoadingSpinner";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import partnertable from "../../widgets/partner-table-collapsable";
export default {
  components: {
    "w-text-input": TextInput,
    "w-drop-down": DropDown,
    "w-datepicker": Datepicker,
    "w-collapse-table": partnertable,
    "w-loadingSpinner": loadingSpinner,
    DatePicker,
    "w-modal": Modal
  },
  data() {
    return {
      gstDuplicate: false,
      selectedDateRange: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      errorMessage: "",
      disableDateBefore: "",
      disableDateAfter: "",
      validityTimePeriod: [],
      gstDisableDateAfter: "",
      gstDisableDateBefore: "",
      openModal: false,
      modeOfGST: "",
      gststatelist: [],
      gstOrginstatelist: [],
      gstStateDropDown: [],
      triggerModal: false,
      lastResponse: "",
      alertModal: false,
      successModal: false,
      categoryCode: "",
      options: [
        { text: "Single Registration", value: "S" },
        { text: "Vertical Registration", value: "V" }
      ],
      selected: "",
      stateCode: "",
      enableSubmit: true,
      loading: false,
      openTrackingModal: false,
      trackingDetails: [],
      roleName: [],
      form: {
        slNo: null,
        categoryCode: null,
        subCategoryCode: null,
        companyCode: null,
        dealerTypeCode: null,
        stateCode: null,
        thresholdTurnoverLimit: null,
        gstEffectiveFrom: null,
        gstEffectiveUpto: null,
        gstNumber: null,
        gstRegistrationDate: null,
        originCountryCode: null,
        originStateCode: null,
        registrationDate: null,
        registrationNumber: null,
        registrationType: null,
        effectiveFrom: null,
        effectiveUpto: null,
        workCountryCode: 100,
        workStateCode: null,
        dontShowApprovedList: false,
        gstButtonEnable: false
      },
      state: {
        disabledDates: {
          from: "",
          to: ""
        }
      },
      gstTableDataList: {
        fields: [
          {
            key: "typeOfRegistration",
            label: "Registration Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "state",
            label: "State",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstinNumber",
            label: "GST Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "thresholdTurnoverLimit",
            label: "Threshold Limit",
            thClass: "thClassRight",
            tdClass: "text-right"
          },
          {
            key: "gstRegistrationDate",
            label: "Registration Date",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "gstGstEffectiveDate",
            label: "GST Effective Period",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "remarks",
            label: "Remarks",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "dealerType",
            label: "Delear Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "toggle_icon",
            label: "",
            thClass: "table-action",
            tdClass: "text-center"
          }
        ],
        items: []
      },
      gstPendingTableDataList: {
        fields: [
          {
            key: "typeOfRegistration",
            label: "Registration Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "state",
            label: "State",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "gstinNumber",
            label: "GST Number",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "thresholdTurnoverLimit",
            label: "Threshold Limit",
            thClass: "thClassRight",
            tdClass: "text-right"
          },
          {
            key: "gstRegistrationDate",
            label: "Registration Date",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "gstGstEffectiveDate",
            label: "GST Effective Period",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "remarks",
            label: "Remarks",
            thClass: "thClassCenter",
            tdClass: "text-center"
          },
          {
            key: "dealerType",
            label: "Delear Type",
            thClass: "thClassLeft",
            tdClass: "text-left"
          },
          {
            key: "toggle_icon",
            label: "",
            thClass: "table-action",
            tdClass: "text-left"
          }
        ],
        items: []
      },
      editModal: false,
      approvedEditList: false,
      partnerDetailsFilterText: "",
      gstDealersDropDown: [],
      countryDropDown: [
        { value: null, text: "Select Country", disabled: true }
      ],
      businessCategory: [],
      businessSubCategory: [],
      partnerDetailInfo: "",
      gstDocumentNumber: "",
      gstActionStatus: "",
      tempGstPendingDetails: [],
      createdCount: 0,
      pendingCount: 0,
      sentbackCount: 0,
      rejectedCount: 0
    };
  },
  watch: {},
  created() {
    this.loading = true;
    this.getpartnerDetails();
  },
  computed: {},
  methods: {
  }
};
</script>

<style scoped>
.orange-dot {
  height: 10px;
  width: 10px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
}
.red-dot {
  height: 10px;
  width: 10px;
  background-color: #f43b3b;
  border-radius: 50%;
  display: inline-block;
}
.yellow-dot {
  height: 10px;
  width: 10px;
  background-color: #f4cf08;
  border-radius: 50%;
  display: inline-block;
}
.blue-dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  background-color: #002d72;
}
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.search-bar .input-group-prepend .input-group-text {
  height: 38px;
  border-radius: 0;
  font-family: "Source Sans Pro", sans-serif;
  border: 1px solid #ced4da;
  background: #f4f4f4;
  font-size: 15px;
  cursor: pointer;
}

.search-bar .form-control {
  height: 38px;
  width: 30px !important;
  border-radius: 0;
  border: 1px solid #ced4da;
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
}

.search-bar .form-control:focus {
  box-shadow: none;
}
.search-bar {
  width: 30% !important;
}
.add-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  border-color: none !important;
  width: 130px !important;
}
.sumbit-approval {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff !important;
  border-color: none !important;
}
.save-gst-button {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  /* width: 130px !important; */
}
.save-gst-button:disabled {
  cursor: not-allowed;
}
.partner-reg {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px;
  text-align: left;
  color: #696969;
}
.partner-reg-subText {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
.sub-heading-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #212529;
}
.action-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #939393;
}
</style>
<style >
.modal-header {
  padding: 5px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-title {
  /* font-family: "Source Sans Pro", sans-serif !important; */
  font-size: 16px !important;
  font-weight: 500;
  color: #ffffff;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer {
  padding: 8px;
  /* margin-left: 4%;
  margin-right: 5%; */
  border-top: 1px solid #dee2e6;
  font-family: "Source Sans Pro", sans-serif;
}
/* .modal-footer > .btn-primary {
  background-color: #0e5d84;
  font-size: 14px;
  font-weight: 500;
  border-color: none !important;
  color: #ffffff !important;
  width: 164px;
  margin-right: 2%;
} */

.custom-control-input:checked ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  font-weight: bold;
  text-align: left;
  color: #002d72 !important;
}
.custom-control-input ~ .custom-control-label > span {
  font-family: "Source Sans Pro", sans-serif !important;
  font-size: 15px !important;
  /* font-weight: bold; */
  text-align: left;
  /* color: #002d72 !important; */
}
.approved-gst {
  /* width: 23%; */
  /* float: left; */
  height: 18px !important;
}
.alertText {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  text-align: center !important;
}
.modal-header .close {
  margin-top: 1px !important;
  padding: 0rem 0rem 0px !important;
  margin: -1rem -1rem -1rem auto;
  border: solid 1px #707070;
  /* color: rgba(0, 0, 0, 0.85); */
  font-family: "Source Sans Pro", sans-serif;
  color: red;
  border-radius: 50%;
  background-color: #ffff;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
  font-size: 17px;
  font-weight: bold;
  opacity: unset !important;
}
</style>
<style>
.thClassLeft {
  background-color: #6192b1;
  color: white;
  text-align: left !important;
}
.thClassright {
  background-color: #6192b1;
  color: white;
  text-align: right !important;
}

.thClassCenter {
  background-color: #6192b1;
  color: white;
  text-align: center !important;
}
.table-action {
  background-color: #6192b1;
  width: 7% !important;
}
/* .dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 7%;
}
.dottedRejected {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e61313;
  float: left;
  margin-top: 3%;
}
.dottedSendback {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #002d72;
  float: left;
  margin-top: 3%;
} */
</style>